import { render, staticRenderFns } from "./InstallAppInstructionPopup.vue?vue&type=template&id=09fa70eb&scoped=true"
import script from "./InstallAppInstructionPopup.vue?vue&type=script&lang=ts"
export * from "./InstallAppInstructionPopup.vue?vue&type=script&lang=ts"
import style0 from "./InstallAppInstructionPopup.vue?vue&type=style&index=0&id=09fa70eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fa70eb",
  null
  
)

export default component.exports